export enum BillingAddonCode {
  AI = 'ai',
  MEMBERS = 'members',
  PORTALS = 'portals',
  TRANSCRIBE = 'transcribe',
  AUTOMATION = 'automation',
  AI_ASSISTANT = 'ai_assistant',
}

export type AddonCode = `${BillingAddonCode}`;

export interface BillingAddonDto {
  id: string;
  code: BillingAddonCode;
  quantity: number;
  maxQuantity?: number;
}

export interface BillingAddon {
  id: string;
  code: BillingAddonCode;
  quantity: number;
  maxQuantity?: number;
}

export function billingAddonFromDto(dto: BillingAddonDto): BillingAddon {
  return {
    id: dto.id,
    code: dto.code,
    quantity: dto.quantity,
    maxQuantity: dto.maxQuantity,
  };
}

export interface AddSubscriptionAddonPayload {
  userId: number;
  subscriptionId: string;
  orgId: string;
  code: BillingAddonCode;
  quantity?: number;
}
